import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Copy, Megaphone, MoreVertical, Pencil, Trash2 } from 'lucide-react';

interface SkillFrameworkActionsProps {
    isRoot: boolean;
    isPublished: boolean;
    isPublishing: boolean;
    onPublish: () => void;
    onEdit: (nodeId: string) => void;
    isDuplicating: boolean;
    onDuplicate: (nodeId: string) => void;
    isDeleting: boolean;
    onDelete: (nodeId: string) => void;
    nodeId: string;
}

const SkillFrameworkActions = ({
    isRoot,
    isPublished,
    isPublishing,
    onPublish,
    onEdit,
    isDuplicating,
    onDuplicate,
    isDeleting,
    onDelete,
    nodeId,
}: SkillFrameworkActionsProps) => {
    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <button
                    type="button"
                    className="h-7 w-7 inline-flex items-center justify-center rounded-md hover:bg-accent"
                >
                    <MoreVertical className="h-4 w-4" />
                </button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="min-w-[150px]">
                <DropdownMenuItem onClick={() => onEdit(nodeId)}>
                    <Pencil className="mr-2 h-4 w-4" />
                    Edit
                </DropdownMenuItem>
                {isRoot && (
                    <DropdownMenuItem
                        disabled={isPublished || isPublishing}
                        onClick={onPublish}
                    >
                        <Megaphone className="mr-2 h-4 w-4" />
                        Publish
                    </DropdownMenuItem>
                )}
                <DropdownMenuItem
                    disabled={isDuplicating || isDeleting}
                    onClick={() => onDuplicate(nodeId)}
                >
                    <Copy className="mr-2 h-4 w-4" />
                    Duplicate
                </DropdownMenuItem>
                <DropdownMenuItem
                    className="text-red-500 focus:text-red-500"
                    disabled={isDeleting}
                    onClick={() => onDelete(nodeId)}
                >
                    <Trash2 className="mr-2 h-4 w-4" />
                    Delete
                </DropdownMenuItem>
            </DropdownMenuContent>
        </DropdownMenu>
    );
};

export default SkillFrameworkActions;
